module.exports = __webpack_public_path__ + "img/for-parents.87b9cb8.svg";